import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { cleanupStaleServiceWorkers, initThemeFromCache, setThemeScope } from '@fitboxx/shared';
import './index.css';
import App from './App';

cleanupStaleServiceWorkers();
// Declare the scope BEFORE the first paint: it is what decides whether this
// document honours the studio's theme at all (Appearance -> "member portal
// follows"). Then paint the cached tokens, so a returning member never
// watches the house default flash into their studio's colours.
setThemeScope('member');
initThemeFromCache();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
